import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import LogViewer from './Components/LogViewer';

// PrivateRoute component to protect dashboard
const PrivateRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem('isAuthenticated'); // Assuming you set this when the user logs in

    if (!isAuthenticated) {
        return <Navigate to="/" />; // Redirect to login if not authenticated
    }

    return children; // If authenticated, render the protected route (children)
};

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split("/").pop()}`
}

function App() {
    return (
        <Router basename={getBasename()}>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/logs/:type"
                    element={
                        <PrivateRoute>
                            <LogViewer />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
